module.exports = __webpack_public_path__ + "CK.png?de5a831f458be87bc4977e8294f7ab74";